export default __webpack_public_path__ + "static/media/3_Quartet.b46f2b5d.mp3";